module.exports = "<span i18n=\"@@strong\">Strong</span>\n<span i18n=\"@@medium\">Medium</span>\n<span i18n=\"@@weak\">Weak</span>\n"